// Chinese translations
export const zh = {
  // Header
  header: {
    searchPlaceholder: "搜索达人、商品、直播、视频、小店或品牌",
    search: "搜索",
    trialVersion: "试用版",
    upgradeTrial: "升级体验版",
    loginRegister: "登录/注册",
    downloadApp: "下载App",
  },

  // Products page
  products: {
    title: "商品榜",
    collapseMore: "收起更多榜单",
    expandMore: "展开更多榜单",
    description: "根据商品在抖音的销售数据排序,快速找到整体大盘下热卖商品",
    all: "全部",
    advancedFilter: "高级筛选",
    price: "价格",
    custom: "自定义",
    yuan: "元",
    to: "至",
    confirm: "确定",
    brand: "品牌",
    selectBrand: "选择品牌",
    livePromotion: "直播推广",
    lowPriceTraffic: "低价引流",
    export: "导出",
    rank: "排行",
    product: "商品",
    productImage: "商品图",
    douyinSales: "抖音销量",
    douyinSalesAmount: "抖音销售额",
    relatedCreators: "关联达人数",
    relatedLiveStreams: "关联直播数",
    relatedVideos: "关联视频数",
    commissionRate: "佣金率",
    action: "操作",
    discoveryTime: "发现时间",
    days: "天",
    noProductsFound: "No products found",
    loadingProducts: "Loading products...",
    tableColumns: {
      rank: "排行",
      product: "商品",
      shop: "小店",
      cardSales: "商品卡销量",
      cardGmv: "商品卡销售额",
      commissionRate: "佣金比例",
      action: "操作",
    },
    tableColumnsAweme: {
      rank: "排行",
      productInfo: "商品信息",
      shopInfo: "小店信息",
      videoSalesVolume: "视频销量",
      videoSalesAmount: "视频销售额",
      commissionRate: "佣金比例",
      estimatedCommission: "预估支付佣金",
      action: "操作",
    },
  },

  // Ranking tabs
  rankingTabs: {
    topHotProducts: "Top 10 热销商品",
    douyinProducts: "抖音商品榜",
    videoProducts: "视频商品榜",
    productCardHot: "商品卡热销榜",
  },

  topVideos: {
    title: "Top 10 热销商品视频",
    description: "抖音热销商品 Top 10 视频，每日更新",
    noData: "该日期暂无视频",
    processing: "处理中",
    position: "排名",
    loading: "加载视频中...",
    error: "无法加载视频列表",
    retry: "重试",
  },

  weeklyVideos: {
    title: "Top 200 周视频",
    description: "每周200个热销商品视频，每周更新",
    noData: "本周暂无视频",
    processing: "处理中",
    error: "无法加载数据",
    retry: "重试",
  },

  // Date types
  dateTypes: {
    daily: "日榜",
    weekly: "周榜",
    monthly: "月榜",
    yearly: "年榜",
    festival: "节日大促",
  },

  // Price ranges
  priceRanges: {
    all: "全部",
    range1: "1-50",
    range2: "50-100",
    range3: "100-300",
    range4: "300-500",
    range5: "500-1000",
    range6: ">1000",
  },

  // Category Modal
  categoryModal: {
    title: "商品分类",
    searchPlaceholder: "请输入关键词搜索商品类目",
    all: "全部",
    lastSelection: "上次选择",
    reset: "重置",
    confirm: "确定",
    search: "搜索",
  },

  // Sidebar
  sidebar: {
    dashboard: "工作台",
    industry: "行业",
    creators: "达人",
    liveStream: "直播",
    productLibrary: "商品库",
    productRanking: "商品榜",
    trendingVideos: "热门视频",
    weeklyVideos: "Top 200 周视频",
    shop: "小店",
    brand: "品牌",
    blog: "博客",
    monitor: "监控",
    advertising: "投放",
    localLife: "本地生活",
    toolbox: "工具箱",
    membershipPlans: "Gia hạn các gói",
    customerService: "在线客服",
    workflow: "工作流",
    workflowUser: "用户工作流",
  },

  // Shops page
  shops: {
    title: "小店销售榜",
    shopLogo: "店铺图",
    rankingTabs: {
      salesRanking: "小店销售榜",
      regionalRanking: "地区小店榜",
    },
    tableColumns: {
      rank: "排行",
      shop: "小店",
      avgPrice: "平均价格",
      salesVolume: "销量",
      salesAmount: "销售额",
      influencerCount: "关联达人数",
    },
  },

  // Product Library
  productLibrary: {
    title: "商品库",
    description: "全网商品数据分析，助力选品决策",
  },

  // Home page
  home: {
    industryOverview: "行业大盘",
    gmv: "GMV",
    sales: "销量",
    live: "直播",
    selfResearch: "自行研院",
    ranking: "榜单",
    monitor: "监控",
    switchIndustry: "切换行业试试~",
    selectedTools: "灰豚精选",
    brandGroupScreen: "品牌集团大屏",
    douyinShop: "抖音小店",
    oceanEngine: "巨量千川",
    oceanResponse: "巨量百应",
    oceanEngine2: "巨量引擎",
    oceanStar: "巨量星图",
    moreTools: "更多工具",
    contentCreation: "内容创作",
    videoEditing: "视频剪辑",
    imageProduction: "图片制作",
    forbiddenWordDetection: "违禁词检测",
    jianying: "剪映",
    quickEdit: "快剪辑",
    miaoyingFactory: "喵影工厂",
    pr: "PR",
    templateImage: "模板制图",
    batchImage: "批量制图",
    smartCutout: "智能抠图",
    manualImage: "手动制图",
    chuangketie: "创客贴",
    inspirationSource: "灵感来源",
    copywritingMaterial: "文案素材",
    musicMaterial: "音乐素材",
    creativeInspiration: "创意灵感",
    weiboHotSearch: "微博热搜",
    baiduTrending: "百度风云榜",
    titleRecommendation: "标题推荐",
    meihuawang: "梅花网",
    topCopywriting: "顶尖文案",
    musicLibrary: "音乐库",
  },

  // Product Detail page
  productDetail: {
    tabs: {
      overview: "数据概览",
      videos: "带货视频",
      reviews: "评价分析",
    },
    salesSummary: "该商品单日最高总销售额在{date} 共{amount}",
    totalSalesAmount: "总销售额",
    totalSalesVolume: "总销量",
    liveStream: "直播",
    video: "视频",
    productCard: "商品卡",
    copyTitle: "复制标题",
    copyLink: "复制链接",
    downloadImage: "下载主图",
    source1688: "1668货源",
    discoveryTime: "发现时间",
    category: "商品分类",
    shop: "小店",
    brand: "品牌",
    shippingLocation: "发货地",
    experienceScore: "体验分",
    noImage: "暂无图片",
    back: "返回",
    dateRanges: {
      days1: "近1天",
      days30: "近30天",
      days7: "近7天",
      days90: "近90天",
      choose: "选择",
    },
    toast: {
      success: "成功",
      titleCopied: "标题已复制",
      linkCopied: "链接已复制",
      imageDownloading: "图片下载中",
      error: "错误",
      imageNotFound: "图片不可用",
    },
    modal1688: {
      title: "1688 商品货源",
      badge: "1688 商品货源",
      viewPrice: "查看价格",
      productTitle: "QYC全友家居现代简约牛皮双人床卧室软包头层牛皮床116206",
      productImage: "商品图片",
      productName: "意式极简真皮床主卧小户型",
      dropshipping: "一件代发",
    },
  },

  // Review Analysis
  reviewAnalysis: {
    stats: {
      all: "全部",
      positive: "好评",
      withImages: "有图",
      followUp: "追评",
      neutral: "中评",
      negative: "差评",
    },
    sectionTitle: "中差评内容",
    reviewType: "评价类型：",
    filterAll: "全部",
    filterNeutral: "中评",
    filterNegative: "差评",
    hasReviewContent: "有评价内容",
    tableHeaders: {
      reviewer: "评价人",
      reviewType: "评价类型",
      reviewContent: "评价内容",
      sku: "SKU",
      reviewTime: "评价时间",
    },
    noData: "暂无数据",
  },

  // Video Product
  videoProduct: {
    filterTabs: {
      all: "全部",
      video: "视频",
      graphic: "图文",
    },
    searchPlaceholder: "请输入关键词进行搜索",
    export: "导出",
    tableHeaders: {
      videoInfo: "视频信息",
      influencerInfo: "达人信息",
      salesVolume: "销量",
      salesAmount: "销售额",
      likes: "点赞数",
      comments: "评论数",
      shares: "分享数",
    },
    noData: "暂无数据~",
  },
};

